import React from "react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import useUpdateQueryParams from "@/hooks/use-update-query-params";
import { cn, formatDate } from "@/lib/utils";

interface ChatUserProps {
    name: string;
    image?: string;
    lastMessage: string;
    active?: boolean;
    id: string;
    date?: string;
    location?: string;
}

const ChatUser: React.FC<ChatUserProps> = ({ name, image, lastMessage, active = false, id, date, location }) => {
    const updateQueryParams = useUpdateQueryParams();
    const handleClick = () => {
        updateQueryParams({ chat_id: id });
    };

    return (
        <button
            onClick={handleClick}
            className={cn(
                active ? "bg-blue-50" : "bg-white",
                "cursor-pointer transition duration-200 hover:bg-blue-50",
                "mb-2 min-w-auto md:min-w-28 flex md:flex-col lg:flex-row items-center  justify-center md:justify-normal gap-0 md:gap-4 rounded-lg p-3 text-start w-full"
            )}
        >
            <Avatar>
                <AvatarImage src={image} alt={name} />
                <AvatarFallback>{name[0]}</AvatarFallback>
            </Avatar>
            <div className="hidden text-start md:block md:text-center lg:text-start">
                <h6 className="line-clamp-1 font-semibold">
                    {JSON.parse(location?.replace(/'/g, '"') || "{}")?.city || "Unknown City"},{" "}
                    {JSON.parse(location?.replace(/'/g, '"') || "{}")?.region || "Unknown Region"},{" "}
                    {JSON.parse(location?.replace(/'/g, '"') || "{}")?.country || "Unknown Country"}
                </h6>
                <div className="hidden lg:inline-flex">
                    <p className="line-clamp-1  text-gray-500 ">{lastMessage}</p>
                </div>
                <p className="text-right text-xs text-gray-400">{date ? formatDate(new Date(date)) : formatDate(new Date())}</p>
            </div>
        </button>
    );
};

export default ChatUser;
